import { ANALYTICS_ROUTES } from '@/lib/analytics-routes.mjs'

export const navigation = [
  { label: 'Discover', url: '/best', menu: true },
  { label: 'Deals', url: '/deals', menu: true },
  { label: 'Stacks', url: '/stacks', menu: true },
  { label: 'Comparisons', url: '/compare', menu: true },
  { label: 'Courses', menu: true },
  { label: 'Blog', url: '/blog', target: '_self' },
  { label: 'About Us', url: '/about', target: '_self', mobileOnly: true },
]

// `reportView` marks items whose real destination depends on which app report
// is currently open (/analytics/report/[slug]/[reportView]). `url` is the
// fallback used when nothing is (e.g. the overview picker) — TrafficNavigation
// resolves the slug-aware href client-side from the current pathname.
export const trafficNavigation = [
  { label: 'Overview', url: ANALYTICS_ROUTES.root, icon: 'report', reportView: 'overview' },
  {
    label: 'AI Appearances',
    url: ANALYTICS_ROUTES.root,
    icon: 'magnifier-sparkle',
    badge: 'Billed',
    reportView: 'search',
  },
  {
    label: 'AI Prompts',
    url: ANALYTICS_ROUTES.root,
    icon: 'chat-sparkle',
    reportView: 'prompts',
  },
  { label: 'AI Activity', url: ANALYTICS_ROUTES.root, icon: 'activity', reportView: 'activity' },
  { label: 'AI Training', url: ANALYTICS_ROUTES.root, icon: 'training', reportView: 'training' },
  {
    label: 'Category',
    url: ANALYTICS_ROUTES.categoryReport,
    icon: 'shapes',
    internal: true,
    reportView: 'category',
    // Unlike the other reportView items, Categories has a real destination
    // with no app in context (the /report/category overview) - so it should
    // navigate there directly instead of blocking on "pick an app first".
    optionalApp: true,
  },
  {
    label: 'Placement Review',
    url: ANALYTICS_ROUTES.placementReview,
    icon: 'clipboard-check',
    internal: true,
    adminOnly: true,
  },
  { label: 'Crawlers', url: ANALYTICS_ROUTES.crawlers, icon: 'eye-open', internal: true },
  { label: 'Sessions', url: ANALYTICS_ROUTES.sessions, icon: 'timer-progress', internal: true },
  { label: 'Pages', url: ANALYTICS_ROUTES.pages, icon: 'pages', internal: true },
  { label: 'Agents', url: ANALYTICS_ROUTES.agents, icon: 'user-sparkle', internal: true },
]

export const trafficUserMenu = [
  {
    label: 'Settings',
    url: ANALYTICS_ROUTES.settings,
    icon: 'sliders',
    internal: true,
    adminOnly: false,
  },
  {
    label: 'Docs',
    url: ANALYTICS_ROUTES.docs,
    icon: 'blog',
    internal: true,
    adminOnly: false,
  },
]
